module.exports = __webpack_public_path__ + "fonts/FixitIcons.433a65a.ttf";